import { createFileRoute, Outlet } from '@tanstack/react-router';

/**
 * Layout route for the whole `/statements/*` subtree (Task 24 — the exact
 * flat-file-route parent/child pitfall `bookings.tsx`'s header comment
 * documents, and `settlementRatesListings.routing.test.tsx` already
 * flagged this file by name as next in line). Because
 * `statements.$period.tsx` exists alongside this file, TanStack Router
 * makes THIS file the PARENT layout of every `/statements/*` URL — the
 * list UI lives in `statements.index.tsx` (`/statements/`), reached only
 * through this file's own `<Outlet/>`.
 */
export const Route = createFileRoute('/statements')({
  component: StatementsLayout,
});

function StatementsLayout() {
  return <Outlet />;
}
